
export const ProductQuery = new TypedDocumentString(`
    query ProductQuery($input: InputProductGet!) {
  catalogProduct(input: $input) {
    ...ProductListing
    __typename
  }
}
    fragment ProductPriceLineItem on ProductPriceLineItem {
  qty
  price {
    priceForHumans
    number
    __typename
  }
  ui {
    ...DiscountUi
    __typename
  }
  __typename
}
fragment ProductListingBoxUiPrice on ProductListingBoxUiPrice {
  bulk {
    price
    qty
    __typename
  }
  endAt
  publicCode {
    code
    percent
    price {
      priceForHumans
      number
      __typename
    }
    __typename
  }
  price {
    priceForHumans
    number
    __typename
  }
  priceTaxless {
    priceForHumans
    number
    __typename
  }
  priceOld {
    priceForHumans
    number
    __typename
  }
  lineItems {
    ...ProductPriceLineItem
    __typename
  }
  __typename
}
fragment ProductListingBoxUiPriceFull on ProductListingBoxUiPrice {
  ...ProductListingBoxUiPrice
  _limited {
    limit
    left
    leftPercent
    __typename
  }
  __typename
}
fragment ProductBoxImages on ListingBoxImages {
  id
  slug
  imageBox {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment ImageTagged on ImageTagged {
  ratio
  type
  img {
    ...Image
    __typename
  }
  tags {
    x
    y
    productId
    groupId
    profileId
    __typename
  }
  __typename
}
fragment ProductSettingsQty on ProductSettingsQty {
  min
  max
  step
  unit
  stockMsg
  __typename
}
fragment ProductOptionsItem on ProductOptionsItem {
  key
  name
  guideProductId
  guideBodyId
  values {
    name
    hsla {
      ...DocumentColorHsla
      __typename
    }
    image {
      ...ImageNodeItem
      __typename
    }
    product {
      productId
      title
      inStock
      slug
      image {
        ...ImageNodeItem
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}
fragment ProductListingValues on ProductListingValues {
  variantCount
  variantAvailableCount
  variantBoxList {
    ...ProductBoxImages
    __typename
  }
  stock
  inStock
  options {
    ...ProductOptionsItem
    __typename
  }
  _uiPrice {
    ...ProductListingBoxUiPriceFull
    __typename
  }
  __typename
}
fragment ProductListing on ProductListing {
  id
  groupId
  sku
  color
  sellerId
  departmentName
  isNew
  slug
  title
  availabilityType
  availableAt
  quantityLimit
  privateVisibility
  _values {
    ...ProductListingValues
    _variantsSeo {
      variantsSeoVariesBy
      items {
        productId
        slug
        sku
        title
        price
        inStock
        image
        color
        size
        material
        pattern
        __typename
      }
      __typename
    }
    __typename
  }
  settingsQty {
    ...ProductSettingsQty
    __typename
  }
  rating {
    count
    rating
    __typename
  }
  updatedAt
  isDiscontinued
  sellerId
  hasBundles
  returnId
  returnsNotAllowed
  careId
  fabricId
  stockLocationId
  weightGrams
  volumeCategory
  factoryId
  certificateIds
  warrantyId
  detailsId
  isDiscounted
  descriptionShort
  descriptionTechnical
  _oldProductSizeHtml
  _oldProductCareHtml
  document {
    _id
    __typename
  }
  collection {
    doc {
      _id
      title {
        value
        __typename
      }
      slug
      __typename
    }
    __typename
  }
  depertments2 {
    key
    title
    __typename
  }
  media {
    images {
      ...ImageTagged
      __typename
    }
    __typename
  }
  attrs {
    key
    value
    uiKey
    uiValue
    uiOption
    __typename
  }
  gender
  audience
  pattern
  material
  height
  length
  width
  gtin
  gtin13
  mpn
  __typename
}
fragment DiscountUi on DiscountUi {
  msg
  amount
  __typename
}
fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}`, {"hash":"043d2d16f8e57ba137a87191c5b80853709cb53fcae588642e4023b0b4c897cb"});